var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaymentsGold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "material-icons-40p"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2071_61210",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 41
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    x: 0.664062,
    y: 0.5,
    width: 40,
    height: 40,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2071_61210)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "payments",
    d: "M23.4431 22.7223C22.0542 22.7223 20.8737 22.2362 19.9014 21.2639C18.9292 20.2917 18.4431 19.1112 18.4431 17.7223C18.4431 16.3334 18.9292 15.1528 19.9014 14.1806C20.8737 13.2084 22.0542 12.7223 23.4431 12.7223C24.832 12.7223 26.0126 13.2084 26.9848 14.1806C27.957 15.1528 28.4431 16.3334 28.4431 17.7223C28.4431 19.1112 27.957 20.2917 26.9848 21.2639C26.0126 22.2362 24.832 22.7223 23.4431 22.7223ZM10.6653 28.2778C9.90143 28.2778 9.2475 28.0058 8.70353 27.4619C8.15956 26.9179 7.88757 26.264 7.88757 25.5001V9.94444C7.88757 9.18055 8.15956 8.52662 8.70353 7.98265C9.2475 7.43867 9.90143 7.16669 10.6653 7.16669H36.2209C36.9848 7.16669 37.6388 7.43867 38.1827 7.98265C38.7267 8.52662 38.9987 9.18055 38.9987 9.94444V25.5001C38.9987 26.264 38.7267 26.9179 38.1827 27.4619C37.6388 28.0058 36.9848 28.2778 36.2209 28.2778H10.6653ZM14.5542 25.5001H32.332C32.332 24.4167 32.7094 23.4977 33.464 22.7431C34.2186 21.9885 35.1376 21.6111 36.2209 21.6111V13.8334C35.1376 13.8334 34.2186 13.456 33.464 12.7014C32.7094 11.9468 32.332 11.0278 32.332 9.94444H14.5542C14.5542 11.0278 14.1769 11.9468 13.4223 12.7014C12.6676 13.456 11.7487 13.8334 10.6653 13.8334V21.6111C11.7487 21.6111 12.6676 21.9885 13.4223 22.7431C14.1769 23.4977 14.5542 24.4167 14.5542 25.5001ZM33.9987 33.8334H5.10978C4.34589 33.8334 3.69196 33.5614 3.14799 33.0174C2.60402 32.4734 2.33203 31.8195 2.33203 31.0556V12.1667H5.10978V31.0556H33.9987V33.8334Z",
    fill: "#D79304"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsGold);
export default __webpack_public_path__ + "static/media/payments-gold.d32d47081a8794440557d3e643ec7c8e.svg";
export { ForwardRef as ReactComponent };